// Shared presentation helpers for the Help & Support surfaces.

export const STATUS_STYLE = {
  new: "border-blue-500/40 text-blue-300 bg-blue-500/5",
  investigating: "border-amber-500/40 text-amber-300 bg-amber-500/5",
  waiting_for_user: "border-fuchsia-500/40 text-fuchsia-300 bg-fuchsia-500/5",
  resolved: "border-emerald-500/40 text-emerald-300 bg-emerald-500/5",
  reopened: "border-red-500/40 text-red-300 bg-red-500/5",
};

export const SEVERITY_STYLE = {
  minor: "border-zinc-700 text-zinc-400",
  incorrect: "border-blue-500/40 text-blue-300",
  major: "border-amber-500/40 text-amber-300",
  critical: "border-red-500/50 text-red-300",
};

export const SEVERITY_HINT = {
  minor: "Cosmetic or barely noticeable",
  incorrect: "Wrong, but usable",
  major: "Unusable for publishing",
  critical: "Nothing works / money involved",
};

export const STATUS_LABEL = {
  new: "New",
  investigating: "Investigating",
  waiting_for_user: "Waiting for user",
  resolved: "Resolved",
  reopened: "Reopened",
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

export const fmtDay = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDuration = (sec) => {
  if (sec == null) return "—";
  const s = Math.round(sec);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return m > 0 ? `${m}m ${String(r).padStart(2, "0")}s` : `${r}s`;
};

export const fmtClock = (sec) => {
  if (sec == null) return "--:--";
  const s = Math.max(0, sec);
  const m = Math.floor(s / 60);
  const r = Math.floor(s % 60);
  return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};

export const fmtBytes = (n) => {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};
